var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsrael(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_17204)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_17204",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_17204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.70635 3C3.76103 3 3 3.50735 3 4.13757V21.8624C3 22.4926 3.76103 23 4.70635 23H18.0909H31.2936C32.239 23 33 22.4926 33 21.8624V4.13757C33 3.50735 32.239 3 31.2936 3H18.0909H4.70635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3602 9.12968L17.2439 11.0596L15.4636 11.061L15 11.0614L16.1214 13L15 14.9386L15.4636 14.939L17.2439 14.9405L18.3602 16.8703L19.4713 14.9423L21.7109 14.9441L20.5906 13.0001L21.7109 11.0561L19.4714 11.0578L18.3602 9.12968ZM18.3592 10.1999L18.854 11.0583L17.8622 11.0591L18.3592 10.1999ZM20.7845 11.5919L20.2818 12.4642L19.7796 11.5927L20.7845 11.5919ZM19.1622 11.5932L19.973 13L19.1622 14.4069L17.5526 14.4057L16.7395 13.0001L17.5526 11.5945L19.1622 11.5932ZM16.9341 11.595L16.4305 12.4657L15.9273 11.5958L16.9341 11.595ZM16.4305 13.5344L16.9342 14.4052L15.9273 14.4044L16.4305 13.5344ZM20.2818 13.5359L20.7845 14.4082L19.7796 14.4074L20.2818 13.5359ZM17.8622 14.941L18.854 14.9418L18.3592 15.8003L17.8622 14.941Z",
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70635 3C3.76103 3 3 3.50735 3 4.13757V7.29251H33V4.13757C33 3.50735 32.239 3 31.2936 3H18.0909H4.70635Z",
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70635 23C3.76103 23 3 22.4926 3 21.8624V18.7075H33V21.8624C33 22.4926 32.239 23 31.2936 23H18.0909H4.70635Z",
    fill: "#0038B8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_17204",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_17204"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_17204",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsrael);
export default __webpack_public_path__ + "static/media/Israel.4e7d7ed53826c82ccff6f85e9f648c1d.svg";
export { ForwardRef as ReactComponent };